// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb","item":"item","level-right":"level-right","level-left":"level-left","bm-btn":"bm-btn","icon":"icon","is-active":"is-active"};